import { translate as libTranslate } from '@fiverr-private/i18n-react';
import { TranslationKeyWithPrefix } from './translate.types';

export const translate = (key: TranslationKeyWithPrefix, options?: Record<string, unknown>): string =>
    libTranslate(`identification_core.${key}`, options);
